/** Party Purpose refers to the connection this party has with the order */
export enum ePartyPurpose {
  borrower = 'borrower',
  buyer = 'buyer',
  client = 'client',
  lender = 'lender',
  order_contact = 'order_contact',
  notarizingAgent = 'notarizingAgent',
  notary = 'notary',
  seller = 'seller',
  settlementAgent = 'settlementAgent',
  titleIssuingAgent = 'titleIssuingAgent',
  underwriter = 'underwriter',
}

export const DisplayPartyPurpose = {
  [ePartyPurpose.borrower]: 'Borrower',
  [ePartyPurpose.buyer]: 'Buyer',
  [ePartyPurpose.seller]: 'Seller',
  [ePartyPurpose.client]: 'Client',
  [ePartyPurpose.lender]: 'Lender',
  [ePartyPurpose.order_contact]: 'Order Contact',
  [ePartyPurpose.notarizingAgent]: 'Notarizing Agent',
  [ePartyPurpose.notary]: 'Notary',
  [ePartyPurpose.settlementAgent]: 'Settlement Agent',
  [ePartyPurpose.titleIssuingAgent]: 'Title Issuing Agent',
  [ePartyPurpose.underwriter]: 'Underwriter',
};
